import classNames from "classnames";
import styles from "./style.module.scss";

interface ContentBodyLoaderProps {
  center?: boolean;
}

export default function ContentBodyLoader({
  center = false,
}: ContentBodyLoaderProps) {
  return (
    <div
      className={classNames(styles.contentBodyLoader, {
        [styles.center]: center,
      })}
    ></div>
  );
}
